var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsolation4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.14 112.92C216 131.75 215.87 150.57 215.75 169.4C185.58 186.81 155.39 204.23 125.21 221.64V153.86C155.5 140.22 185.83 126.56 216.14 112.93V112.92Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4399 99.4995V174.259L125.23 221.639V153.859L80.3298 74.9795L35.4399 99.4995Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8398 91.5497C24.3798 94.1897 29.8999 96.8497 35.4399 99.4997L80.3298 74.9797C100.44 104.04 120.53 133.09 140.64 162.15C170.81 145.77 200.98 129.41 231.16 113.04C211.13 81.0197 191.11 48.9897 171.08 16.9697C140.83 30.3597 110.58 43.7397 80.3298 57.1297C59.8398 68.6097 39.3398 80.0897 18.8398 91.5497Z",
    fill: "#156740"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8398 91.5504L35.4399 99.5004L80.3298 74.9804L125.23 153.86L140.64 162.16L80.3298 57.1504L18.8398 91.5604V91.5504Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.3 233.03C122.69 231.54 120.09 230.05 117.48 228.55L108.02 222.92L35.4399 179.64V169.54L117.42 217.41C120.02 218.82 122.61 220.23 125.21 221.64C125.24 225.44 125.27 229.24 125.3 233.03Z",
    fill: "#FEE4E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.62 178.82L215.75 169.4C185.57 186.81 155.39 204.23 125.21 221.64C125.24 225.44 125.27 229.24 125.3 233.03L215.61 178.82H215.62Z",
    fill: "#FECECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolation4);
export default __webpack_public_path__ + "static/media/isolation4.bdaa7a418895d4dd208a6fa2c1012052.svg";
export { ForwardRef as ReactComponent };